import FeatureSettingsApi from '@/api/featureSettings'
import Sentry from '@/services/sentry'
import { trackFeatureSettings } from '@/business-logic/ai-tracking'

const SET_FEATURE_SETTINGS = 'SET_FEATURE_SETTINGS'

const _state = {
  featureSettings: {},
  isFeatureSettingsLoaded: false,
}

const _getters = {
  isFeatureDisabled: (state) => (featureName) => {
    const feature = state.featureSettings[featureName]
    return feature ? feature.isDisabled : false
  },
  featureDisabledReason: (state) => (featureName) => {
    const feature = state.featureSettings[featureName]
    return feature ? feature.disabledReason : null
  },
  isFeatureSettingsLoaded: (state) => state.isFeatureSettingsLoaded,
}

let prefetchedFeatureSettingsRequest = null

const actions = {
  // Not committed here: the next fetchFeatureSettings({ reusePrefetch: true }) commits the result.
  prefetchFeatureSettings() {
    prefetchedFeatureSettingsRequest = FeatureSettingsApi.getFeatureSettings()
    // Marks the rejection handled until fetchFeatureSettings awaits it, which still sees the error.
    prefetchedFeatureSettingsRequest.catch(() => {})
  },
  async fetchFeatureSettings({ commit }, options) {
    // Any fetch retires the prefetch: one started before a settings save must never be committed after it.
    const prefetchedRequest = options?.reusePrefetch ? prefetchedFeatureSettingsRequest : null
    prefetchedFeatureSettingsRequest = null
    try {
      trackFeatureSettings({ stage: 'started' })
      const featureSettings = await (prefetchedRequest || FeatureSettingsApi.getFeatureSettings())
      commit(SET_FEATURE_SETTINGS, featureSettings)
    } catch (e) {
      // A 401 here means the cached isAuth context outlived the presenter session — expected, not a bug.
      if (e?.status !== 401) {
        Sentry.captureException(e)
      }
      trackFeatureSettings({ stage: 'failed', error: e })
      // Fail-open: mark as loaded with empty settings (all features enabled)
      commit(SET_FEATURE_SETTINGS, {})
    }
  },
}

const mutations = {
  // eslint-disable-next-line no-param-reassign
  [SET_FEATURE_SETTINGS](state, featureSettings) {
    state.featureSettings = featureSettings // eslint-disable-line no-param-reassign
    state.isFeatureSettingsLoaded = true // eslint-disable-line no-param-reassign
  },
}

export default {
  namespaced: true,
  state: _state,
  getters: _getters,
  actions,
  mutations,
}
